const proptypes = {
  SHAP: 'shap',
  SCALE: 'scale',
  OTHER: 'other',
  ALL: 'all',
}

export default proptypes
